export function toIntOrUndefined(text: string|undefined) {
  return text
    ? parseInt(text)
    : undefined;
}